module.exports = __webpack_public_path__ + "static/media/Icon_Pleteo_White.3c4cd366.png";